/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { result } from 'underscore';
import PropTypes from 'prop-types';

const setTranslateX = (el, value) => {
  // eslint-disable-next-line no-param-reassign
  el && el.style && (el.style.transform = `matrix(1, 0, 0, 1, ${value}, 0)`);
};
const getTranslateX = (el) => {
  const matrix = el.style.transform.replace(/\s/g, '');
  const arr = matrix.split(',');
  const translateX = result(arr, 4, '0');
  return parseInt(translateX, 10);
};

export class VirtualScrollbar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.view = React.createRef();
    this.child = React.createRef();
    this.isDown = false;
    this.prev = 0;
  }

  componentDidMount() {
    this.view.current.addEventListener('scroll', this.onViewScroll);
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);
  }

  componentWillUnmount() {
    this.view.current.removeEventListener('scroll', this.onViewScroll);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  onMouseUp = () => {
    this.isDown = false;
  }

  onMouseDown = (e) => {
    this.isDown = true;

    let offsetLeft;
    if (this.child.current.style.transform) {
      offsetLeft = getTranslateX(this.child.current);
    } else {
      offsetLeft = 0;
    }
    this.prev = offsetLeft - e.clientX;
  }

  onMouseMove = (e) => {
    if (this.isDown) {
      let offsetX = e.clientX + this.prev;
      const thumbWidth = (this.props.width * this.props.width) / this.props.viewWidth;

      // set virtual bar
      if (offsetX < 0) {
        offsetX = 0;
      } else if (offsetX > this.props.width - thumbWidth) {
        offsetX = this.props.width - thumbWidth;
      }
      setTranslateX(this.child.current, offsetX);

      // set physical bar
      const viewOffsetX = (offsetX / this.props.width) * this.props.viewWidth;
      this.view.current.scrollLeft = viewOffsetX;
    }
  }

  onViewScroll = (e) => {
    const viewOffsetX = e.target.scrollLeft;
    const offsetX = (viewOffsetX / this.props.viewWidth) * this.props.width;
    setTranslateX(this.child.current, offsetX);
  }

  render() {
    const parentStyle = {
      ...this.props.style,
      width: this.props.width,
      height: this.props.height,
    };

    const childStyle = {
      width: (this.props.width * this.props.width) / this.props.viewWidth,
      height: this.props.height,
      userSelect: 'none',
    };

    return (
      <div className="virtual-scrollbar-container">
        <div>{React.cloneElement(this.props.children, { ref: this.view })}</div>
        <div
          className="parent-bar"
          style={parentStyle}
          onMouseMove={this.onMouseMove}
        >
          <div
            className="child-bar"
            onMouseDown={this.onMouseDown}
            onMouseUp={this.onMouseUp}
            ref={this.child}
            style={childStyle}
          />
        </div>
      </div>
    );
  }
}

VirtualScrollbar.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number.isRequired,
  viewWidth: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
};

VirtualScrollbar.defaultProps = {
  height: 15,
  style: {},
};
